/* AIOS-CARD-CART-CTA — the corner cart icon on collection cards proxies a click to
   the (hidden) native quick-add button, so all add-to-cart / choose-options logic is
   reused. The cart button sits UNDER Dawn's full-card link overlay, so (exactly like
   the wishlist heart) we detect it via elementsFromPoint and reroute the click,
   blocking the navigation. Registered before the theme's own card handlers + uses
   stopImmediatePropagation so nothing else acts on the same click. */
(function(){
  if (window.__aiosCardCartProxy) return;
  window.__aiosCardCartProxy = 1;
  document.addEventListener('click', function(e){
    var x = e.clientX, y = e.clientY;
    if (x == null && e.changedTouches && e.changedTouches[0]) { x = e.changedTouches[0].clientX; y = e.changedTouches[0].clientY; }
    var cart = null;
    if (x != null) {
      var stack = document.elementsFromPoint(x, y);
      for (var i = 0; i < stack.length; i++) {
        if (stack[i].closest && stack[i].closest('[data-aios-cart-proxy]')) { cart = stack[i].closest('[data-aios-cart-proxy]'); break; }
      }
    }
    if (!cart && e.target.closest) { cart = e.target.closest('[data-aios-cart-proxy]'); }
    if (!cart) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = cart.closest('.card-wrapper');
    var btn = card && card.querySelector('.quick-add__submit');
    if (btn) btn.click();
  }, true);
})();


/* AIOS-CARD-INCART — colour the corner bag icon orange when the product is already in the cart */
(function(){
  if (window.__aiosInCartSync) return;
  window.__aiosInCartSync = 1;
  function sync(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var handles = {};
      (cart.items||[]).forEach(function(it){ if(it.handle) handles[it.handle]=1; });
      document.querySelectorAll('.card-wrapper').forEach(function(card){
        var link = card.querySelector('a[href*="/products/"]');
        var m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        var h = m && m[1];
        card.classList.toggle('aios-in-cart', !!(h && handles[h]));
      });
    }).catch(function(){});
  }
  window.aiosInCartSync = sync;
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) sync(); });
  document.addEventListener('cart:refresh', sync);
  try { if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, sync); } catch(e){}
})();
